import { Injectable, inject } from '@angular/core';
import { Firestore, collectionData, collection, doc, docData, query, orderBy, updateDoc, where } from '@angular/fire/firestore';
import { Observable, from } from 'rxjs';
import { User } from './user.model';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  private readonly firestore = inject(Firestore);

  getUsers(): Observable<User[]> {
    const usersRef = collection(this.firestore, 'users');
    const usersQuery = query(usersRef, orderBy('displayName', 'asc'));
    return collectionData(usersQuery, { idField: 'id' }) as Observable<User[]>;
  }

  getUsersByRoles(roles: string[]): Observable<User[]> {
    const usersRef = collection(this.firestore, 'users');
    const usersQuery = query(
      usersRef,
      where('role', 'in', roles),
      orderBy('displayName', 'asc')
    );
    return collectionData(usersQuery, { idField: 'id' }) as Observable<User[]>;
  }

  getUser(id: string): Observable<User | undefined> {
    const userDoc = doc(this.firestore, 'users', id);
    return docData(userDoc, { idField: 'id' }) as Observable<User | undefined>;
  }

  updateUser(userId: string, data: Partial<User>): Observable<void> {
    const userDoc = doc(this.firestore, 'users', userId);
    return from(updateDoc(userDoc, data));
  }
}
